import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery } from "@tanstack/react-query";
import getOrganisationList from "../http/getOrganisationList";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

const useOrganisationList = () => {
  const { getToken } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const fetchOrganisations = useQuery(
    ["orgs"],
    async () => {
      return getOrganisationList(await getAuthTokenBlocking(getToken, relogin));
    },
    {
      // Allow query to be mounted multiple times on the same page without re-fetching
      staleTime: 5 * 60 * 1000,
    }
  );

  return {
    fetchOrganisations,
  };
};

export default useOrganisationList;
